import ChevronRight from '@ixigo/icons/ChevronRight';
import CustomerServiceFilled from '@ixigo/icons/CustomerServiceFilled';
import ListItem from '@ixigo/iui/ListItem';
import ListItemIcon from '@ixigo/iui/ListItemIcon';
import ListItemText from '@ixigo/iui/ListItemText';
import cn from '@repo/shared/utils/cn';
import { useParams } from '@tanstack/react-router';
import { SectionHeader } from '@/components/section-header';
import { useNavigate } from '@/lib/navigation';

interface CustomerHelpProps extends React.ComponentPropsWithoutRef<'div'> {}

export const CustomerHelp = ({ className, ...props }: CustomerHelpProps) => {
	const { bookingId } = useParams({ from: '/_auth/trips/$bookingId/' });
	const navigate = useNavigate();
	return (
		<div className={cn('flex flex-col', className)} {...props}>
			<SectionHeader title="Need Help" />
			<ListItem
				className="py-10 hover:bg-transparent"
				disablePadding
				onClick={() => {
					navigate({
						to: '/support',
						search: { bookingId },
						resetScroll: true,
					});
				}}
			>
				<ListItemIcon
					type="avatar"
					className="items-center justify-center w-6 h-6 text-secondary"
				>
					<CustomerServiceFilled />
				</ListItemIcon>
				<ListItemText
					primary="Customer Service"
					secondary="Get answers on our Help Centre or chat with us instantly"
					className="lg:font-normal"
				/>
				<ListItemIcon type="avatar" className="justify-end items-center">
					<ChevronRight data-testid="chevron-right" />
				</ListItemIcon>
			</ListItem>
		</div>
	);
};
